/**
 * js缓存
 *
 * @author yusangeng@outlook.com
 */
import { Cache, CacheStatus } from './cache';
import { getInstance } from '../singleton';
var jsCache = getInstance('jsCache', function () {
    return new Cache(function (key) {
        return {
            url: key,
            status: CacheStatus.NONE,
            el: null,
            error: null,
            reject: null,
            exportThing: void 0
        };
    });
});
export default jsCache;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoianMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2FjaGUvanMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUVILE9BQU8sRUFBRSxLQUFLLEVBQWEsV0FBVyxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBQ3ZELE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFPMUMsSUFBTSxPQUFPLEdBQUcsV0FBVyxDQUFDLFNBQVMsRUFBRTtJQUNyQyxPQUFPLElBQUksS0FBSyxDQUFjLFVBQUMsR0FBVztRQUN4QyxPQUFPO1lBQ0wsR0FBRyxFQUFFLEdBQUc7WUFDUixNQUFNLEVBQUUsV0FBVyxDQUFDLElBQUk7WUFDeEIsRUFBRSxFQUFFLElBQUk7WUFDUixLQUFLLEVBQUUsSUFBSTtZQUNYLE1BQU0sRUFBRSxJQUFJO1lBQ1osV0FBVyxFQUFFLEtBQUssQ0FBQztTQUNwQixDQUFBO0lBQ0gsQ0FBQyxDQUFDLENBQUE7QUFDSixDQUFDLENBQUMsQ0FBQTtBQUVGLGVBQWUsT0FBTyxDQUFBIn0=